// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textarea__3w7OL","text":"text__pcHXs"};